<script setup lang="ts">
const props = defineProps({
  document: {
    type: Object,
    required: true,
  },
});

const title = computed(() => props.document.data.title);
const description = computed(() => props.document.data.description);
const image = computed(() => props.document.data.image);
</script>

<template>
  <section class="mx-auto">
    <div
      class="mb-10 mt-40 flex w-full max-w-[1048px] flex-col items-center justify-center px-6 -md:max-w-none -md:px-4 -sm:mt-28"
    >
      <RichText
        :text="title"
        class="text-[50px] font-extralight -md:text-4xl -md:leading-[48px] -sm:text-3xl"
      />
      <hr class="my-6 w-[50px] border-[0.5px] border-gray-800" />
    </div>

    <div
      class="mx-auto h-[600px] w-full max-w-[960px] -sm:h-[400px] -xs:h-[300px]"
    >
      <PImage
        :image-object="image"
        sizes="xs:100vw sm:100vw md:100vw"
        class="h-full w-full object-cover"
      />
    </div>

    <div class="mx-auto mt-10 px-6 -md:mt-10 -md:px-4">
      <RichText
        :text="description"
        class="my-4 hyphens-auto break-words border-l-2 border-gray-400 pl-6 text-base leading-7 text-gray-600 -sm:text-sm -sm:leading-5"
      />
    </div>
  </section>
</template>
